import React from "react";

import { Redirect, Route, Switch } from "react-router-dom";

import {
  CONTENTS_ROUTE,
  EXTERNAL_CONTENTS_ROUTE,
  FAST_CONTENTS_ROUTE,
  LIVE_CONTENTS_ROUTE,
} from "./routes";
import useAbility from "../../hooks/useAbility";
import ContentList from "../content/ContentList";
import ContentPage from "../content/ContentPage";

import type { JSX } from "react";

function ContentRoutes(): JSX.Element {
  const { getHomePageURL, isFastOnly } = useAbility();

  return (
    <Switch>
      {isFastOnly ? (
        <Route
          path={[
            LIVE_CONTENTS_ROUTE,
            FAST_CONTENTS_ROUTE,
            EXTERNAL_CONTENTS_ROUTE,
          ]}
        >
          <Redirect to={getHomePageURL()} />
        </Route>
      ) : null}
      <Route exact component={ContentList} path={`${CONTENTS_ROUTE}/:type`} />
      <Route component={ContentPage} path={`${CONTENTS_ROUTE}/:type/:id`} />
    </Switch>
  );
}
export default ContentRoutes;
